<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper">
            <h2 class="title d-flex mb-4">
                <div class="flex-shrink-0 mr-2">川柳大小事</div>
                <div class="text-sm">
                    點選下方資訊查看，臺中七大河川的相關最新消息及活動!了解河川大小事、守護臺中河川。
                </div>
            </h2>
            <ul class="everything-wrapper">
                <li>
                    <a href="" class="item" @click.prevent="goView('news')">
                        <img src="@/assets/inform_img_news.png" alt="" />
                        <div class="title">最新消息</div>
                    </a>
                </li>
                <li>
                    <a href="" class="item" @click.prevent="goView('event')">
                        <img src="@/assets/inform_img_event.png" alt="" />
                        <div class="title">活動行事曆</div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_news.jpg'),
                },
            ],
        };
    },
    methods: {
        goView(name) {
            this.$router.push(`${this.$route.path}/${name}`);
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
